import { gql } from '@apollo/client';

export const STAGE_TASK_DETAILS_FRAGMENT = gql`
  fragment StageTaskDetailsFragment on StageTask {
    id
    name
    ctaLabel
    creatorAccess
    fieldSchemas {
      id
      name
      type
      description
      metaData
      isMandatory
      fieldOrder
      fieldValues {
        id
        value
        metadata
        __typename
      }
      __typename
    }
    stage {
      id
      name
      __typename
    }
    __typename
  }
`;

export const GET_STAGE_TASK_DETAILS = gql`
  query CustomStageTaskDetailsQuery($programId: Int!, $stageId: Int!, $memberId: Int!) {
    getStageTaskDetails(programId: $programId, stageId: $stageId, memberId: $memberId) {
      ...StageTaskDetailsFragment
      __typename
    }
  }
  ${STAGE_TASK_DETAILS_FRAGMENT}
`;
